import Uppy from '@uppy/core';
import Dashboard from '@uppy/dashboard';
import Tus from '@uppy/tus';

import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';

const uppyDashboard = new Uppy()
.use(Dashboard, {
	inline: true,
	target: '#app',
	showProgressDetails: true,
	fileManagerSelectionType: 'files',
	proudlyDisplayPoweredByUppy: false,
	width: '100%',
	height: '100vh',
})
.use(Tus, {
	endpoint: '/tus',
	// chunkSize: 2**20,
})
